import { Col, Divider, Form, Row } from 'antd';
import Modal from 'antd/es/modal/Modal';
import { useFormik } from 'formik';
import { FC } from 'react';
import * as Yup from 'yup';
import Text from 'antd/es/typography/Text';
import Flex from 'antd/es/flex';
import { MButton, MTextArea } from '@Components/Base';
import styles from './AddRemarks.module.css';
import { ButtonsFooter } from '../../common/ButtonsFooter';

export type AddRemarksFormValues = {
  remarks: string;
};

const AddRemarksSchema: Yup.Schema<AddRemarksFormValues> = Yup.object().shape({
  remarks: Yup.string().required('Value is required'),
});

interface AddRemarksProps {
  onSubmit?: (values: AddRemarksFormValues) => void;
  onCancel?: () => void;
}

const AddRemarks: FC<AddRemarksProps> = ({ onCancel, onSubmit }) => {
  const initialValuesForm: AddRemarksFormValues = {
    remarks: '',
  };

  const formik = useFormik({
    initialValues: initialValuesForm,
    onSubmit: (values: AddRemarksFormValues) => onSubmit?.(values),
    validationSchema: AddRemarksSchema,
  });

  const customButtons = (
    <ButtonsFooter>
      <MButton
        onClick={() => {
          onCancel?.();
        }}
        type="tertiary"
      >
        Cancel
      </MButton>
      <MButton
        type="primary"
        disabled={!formik.isValid}
        onClick={() => {
          formik.submitForm();
        }}
      >
        Submit
      </MButton>
    </ButtonsFooter>
  );

  return (
    <Modal
      open
      onCancel={() => onCancel?.()}
      footer={customButtons}
      title="Add Remarks"
    >
      <Divider />
      <form
        noValidate
        onSubmit={(e) => {
          e.preventDefault();
          formik.submitForm();
        }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label="Recommendations/Remarks"
              className={styles.formItem}
            >
              <MTextArea
                name="remarks"
                maxLength={20}
                placeholder="Insert Remarks"
                onChange={(value) => {
                  formik.setFieldValue('remarks', value.target.value);
                }}
              />
              <Flex justify="end">
                <Text type="secondary">
                  {formik.values.remarks?.length || 0}/20
                </Text>
              </Flex>
              {formik.errors.remarks && (
                <Flex justify="end">
                  <Text type="danger">{formik.errors.remarks}</Text>
                </Flex>
              )}
            </Form.Item>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export default AddRemarks;
